// Served from Cloudflare R2 (bucket lofi-cafe-media, v1/ prefix) so GIF traffic stays off Vercel's per-request billing.
// public/gifs stays deployed until tabs still running the old bundle have reloaded.
export default function getGifUrl(id) {
  return "https://media.lofi.cafe/v1/gifs/" + id + ".gif";
}
